const STORAGE_KEY = 'qgc_trade_quote_list';

  /* ---- Hide any third-party stock/location widget (e.g. GEO Stock app) that might inject into this page ---- */
  (function hideThirdPartyStockWidget(){
    function sweep(){
      document.querySelectorAll('[id*="inventoryLocation"], [class*="inventoryLocation"]').forEach(function(el){
        el.style.display = 'none';
      });
    }
    sweep();
    if(document.body){
      new MutationObserver(sweep).observe(document.body, {childList:true, subtree:true});
    }
  })();

  /* ---- Option B availability styling (injected so no CSS file edit is needed) ---- */
  (function injectAvailabilityStyles(){
    if(document.getElementById('qgc-avail-style')) return;
    var s = document.createElement('style');
    s.id = 'qgc-avail-style';
    s.textContent = '.tag-card .stock.is-unavailable,#stockBadge.is-unavailable{background:#f3e6e4 !important;color:#8a2e22 !important;}'
      + '.tag-card.is-state-unavailable .img{opacity:.55;filter:grayscale(35%);}'
      + '.geo-stock .ships-to-line{display:flex;flex-wrap:wrap;align-items:center;gap:6px;margin:10px 0 6px;}'
      + '.geo-stock .ships-to-label{font-size:13px;opacity:.75;margin-right:2px;}'
      + 'button.geo-chip{font:inherit;font-size:12px;line-height:1;padding:6px 10px;border:1px solid rgba(0,0,0,.2);border-radius:999px;background:transparent;color:inherit;cursor:pointer;}'
      + 'button.geo-chip:hover{border-color:currentColor;}'
      + 'button.geo-chip.is-current{background:#1f3d2b;border-color:#1f3d2b;color:#fff;}'
      + '.geo-stock .geo-none{font-size:13px;color:#8a2e22;}'
      + '.geo-stock-alt{margin:10px 0 14px;padding:12px 14px;border:1px solid #e7cfcb;border-radius:8px;background:#fbf4f3;font-size:14px;}'
      + '.geo-stock-alt .geo-alt-title{font-weight:600;margin-bottom:6px;color:#8a2e22;}'
      + '.geo-stock-alt .geo-alt-chips{display:flex;flex-wrap:wrap;gap:6px;margin:8px 0;}'
      + '.geo-stock-alt .geo-alt-note{font-size:12px;opacity:.8;}';
    document.head.appendChild(s);
  })();

  function loadList(){ try{ return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }catch(e){ return []; } }
  function saveList(list){ localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
  let quoteList = loadList();

  /* ---- State-based location ---- */
  const STATE_KEY = 'qgc_trade_state';
  const SHIPPED_STATES = ['NSW','QLD','VIC','SA','TAS','ACT'];
  const ALL_STATES = [
    {code:'NSW', label:'New South Wales'},
    {code:'QLD', label:'Queensland'},
    {code:'VIC', label:'Victoria'},
    {code:'WA',  label:'Western Australia'},
    {code:'SA',  label:'South Australia'},
    {code:'TAS', label:'Tasmania'},
    {code:'ACT', label:'Australian Capital Territory'},
    {code:'NT',  label:'Northern Territory'}
  ];
  /* 'ALL' = All states: no single-state filtering, but listings are limited to products stocked in at least one serviced state.
     getState() returns '' for ALL so per-state checks (ticks, sorting, notices) fall back to 'any state'. */
  function rawState(){ try{ return localStorage.getItem(STATE_KEY) || ''; }catch(e){ return ''; } }
  function getState(){ const s = rawState(); return s === 'ALL' ? '' : s; }
  function isShipped(code){ return SHIPPED_STATES.indexOf(code) !== -1; }
  function setState(code){
    localStorage.setItem(STATE_KEY, code);
    try{
      const u = new URL(location.href);
      if(u.searchParams.has('page')){ u.searchParams.delete('page'); history.replaceState(null, '', u.pathname + u.search + u.hash); }
    }catch(e){}
    updateStateUI();
    applyStateFilter();
    document.dispatchEvent(new CustomEvent('qgc:stateChanged', {detail:{state:code}}));
  }
  function renderDropdown(){
    const dd = document.getElementById('stateDropdown');
    if(!dd) return;
    const current = rawState();
    dd.innerHTML = '<div class="state-option state-option--all' + (current==='ALL'?' active':'') + '" data-state="ALL">All states<span class="tag">All</span></div>' + ALL_STATES.map(function(s){
      const shipped = isShipped(s.code);
      const cls = 'state-option' + (s.code===current?' active':'') + (shipped?'':' unavailable');
      return '<div class="'+cls+'" data-state="'+s.code+'">'+s.label+'<span class="tag">'+s.code+(shipped?'':' · not serviced')+'</span></div>';
    }).join('');
    dd.querySelectorAll('.state-option').forEach(function(el){
      el.addEventListener('click', function(){
        setState(el.dataset.state);
        dd.classList.remove('open');
      });
    });
  }
  function renderFirstVisitGrid(){
    const grid = document.getElementById('stateFirstVisitGrid');
    if(!grid) return;
    grid.innerHTML = ALL_STATES.map(function(s){
      const shipped = isShipped(s.code);
      return '<div class="state-btn'+(shipped?'':' disabled')+'" data-state="'+s.code+'" title="'+s.label+'">'+s.code+'</div>';
    }).join('') + '<div class="state-btn state-btn--all" data-state="ALL" title="Show products from all states" style="grid-column:1 / -1;">All states</div>';
    grid.querySelectorAll('.state-btn:not(.disabled)').forEach(function(el){
      el.addEventListener('click', function(){
        setState(el.dataset.state);
        document.getElementById('stateFirstVisitOverlay').classList.remove('open');
      });
    });
  }
  function updateStateUI(){
    const label = document.getElementById('stateSelectLabel');
    const current = rawState();
    if(label) label.textContent = current === 'ALL' ? 'All states' : (current ? current : 'Shop by state');
    renderDropdown();
  }

  /* ---- Availability helpers ---- */
  function cardAvailable(card, current){
    if(!current || !isShipped(current)) return true;
    const states = (card.dataset.states||'').split(',').map(function(s){return s.trim();}).filter(Boolean);
    const synced = card.dataset.synced === '1';
    return (!synced && states.length===0) || states.indexOf(current) !== -1;
  }
  function labelCards(grid, current){
    grid.querySelectorAll('.tag-card').forEach(function(card){
      const synced = card.dataset.synced === '1';
      const available = cardAvailable(card, current);
      const markUnavailable = !!(current && isShipped(current) && synced && !available);
      /* Client rule: products with no stock in the selected state are not shown at all */
      card.style.display = markUnavailable ? 'none' : '';
      const stockEl = card.querySelector('.stock');
      if(stockEl){
        if(stockEl.dataset.defaultText === undefined) stockEl.dataset.defaultText = stockEl.textContent;
        if(current && isShipped(current) && synced){
          stockEl.textContent = available ? 'In stock' : 'Unavailable';
        } else {
          stockEl.textContent = stockEl.dataset.defaultText;
        }
        stockEl.classList.toggle('is-unavailable', markUnavailable);
      }
      card.classList.toggle('is-state-unavailable', markUnavailable);
    });
  }

  /* ---- Collection pages: load the WHOLE collection, keep only products in stock for the selected state, paginate client-side ---- */
  const fullSortCache = new WeakMap();
  function loadAllCards(grid){
    const cached = fullSortCache.get(grid);
    if(cached) return cached;
    const base = grid.dataset.collectionUrl;
    const params = new URLSearchParams(location.search);
    params.delete('page');
    params.set('section_id', 'trade-collection-all');
    if(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main' && Shopify.theme.id){
      params.set('preview_theme_id', Shopify.theme.id);
    }
    function fetchPage(n){
      const p = new URLSearchParams(params);
      p.set('page', n);
      return fetch(base + '?' + p.toString(), {credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
        .then(function(html){
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const wrap = doc.querySelector('[data-trade-all]');
          if(!wrap) throw new Error('sort data section missing');
          return {pages: parseInt(wrap.dataset.pages || '1', 10), cards: Array.prototype.slice.call(wrap.querySelectorAll('.tag-card'))};
        });
    }
    const promise = fetchPage(1).then(function(first){
      const rest = [];
      for(let i = 2; i <= first.pages; i++) rest.push(fetchPage(i));
      return Promise.all(rest).then(function(others){
        let all = first.cards;
        others.forEach(function(o){ all = all.concat(o.cards); });
        return all;
      });
    });
    fullSortCache.set(grid, promise);
    promise.catch(function(){ fullSortCache.delete(grid); });
    return promise;
  }
  function currentUrlPage(){
    const p = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
    return isNaN(p) || p < 1 ? 1 : p;
  }
  function applyFullSort(grid, current){
    if(!current || !isShipped(current)) return; /* no state yet: keep Shopify's own order */
    const token = String(Date.now()) + Math.random();
    grid.dataset.sortToken = token;
    loadAllCards(grid).then(function(all){
      if(grid.dataset.sortToken !== token || getState() !== current) return;
      const avail = all.filter(function(c){ return cardAvailable(c, current); });
      const per = parseInt(grid.dataset.perPage || '24', 10);
      grid.__tradeSorted = {ordered: avail, per: per, pages: Math.max(1, Math.ceil(avail.length / per)), state: current};
      renderSortedPage(grid, currentUrlPage(), false);
    }).catch(function(err){
      if(window.console) console.warn('QGC trade sort: kept default order.', err);
    });
  }
  function renderSortedPage(grid, page, scroll){
    const s = grid.__tradeSorted;
    if(!s) return;
    page = Math.min(Math.max(1, page), s.pages);
    const frag = document.createDocumentFragment();
    s.ordered.slice((page - 1) * s.per, page * s.per).forEach(function(c){ frag.appendChild(document.importNode(c, true)); });
    grid.innerHTML = '';
    grid.appendChild(frag);
    labelCards(grid, getState());
    let none = grid.parentElement ? grid.parentElement.querySelector('.state-none-notice') : null;
    if(s.ordered.length === 0){
      if(!none){
        none = document.createElement('div');
        none.className = 'empty-state state-none-notice';
        grid.insertAdjacentElement('afterend', none);
      }
      none.textContent = 'Nothing in this range is currently in stock for ' + s.state + '. Email trade@queensgardencentre.com.au and we will let you know when it is.';
    } else if(none){
      none.remove();
    }
    renderSortedPagination(grid, page);
    if(scroll){
      const top = grid.getBoundingClientRect().top + window.pageYOffset - 120;
      window.scrollTo({top: top < 0 ? 0 : top, behavior: 'smooth'});
    }
  }
  function renderSortedPagination(grid, page){
    const s = grid.__tradeSorted;
    const nav = grid.parentElement ? grid.parentElement.querySelector('[data-trade-pagination]') : null;
    if(!nav) return;
    if(s.pages <= 1){ nav.innerHTML = ''; nav.style.display = 'none'; return; }
    nav.style.display = '';
    function link(p, label){
      const u = new URL(location.href);
      u.searchParams.set('page', p);
      return '<a href="' + u.pathname + u.search + '" data-trade-page="' + p + '">' + label + '</a>';
    }
    let h = '';
    if(page > 1) h += link(page - 1, '&larr; Prev');
    let lastShown = 0;
    for(let p = 1; p <= s.pages; p++){
      if(p === 1 || p === s.pages || Math.abs(p - page) <= 2){
        if(lastShown && p - lastShown > 1) h += '<span>&hellip;</span>';
        h += (p === page) ? '<span class="current">' + p + '</span>' : link(p, p);
        lastShown = p;
      }
    }
    if(page < s.pages) h += link(page + 1, 'Next &rarr;');
    nav.innerHTML = h;
  }
  document.addEventListener('click', function(e){
    const a = e.target.closest('[data-trade-page]');
    if(!a) return;
    const nav = a.closest('[data-trade-pagination]');
    const grid = nav && nav.parentElement ? nav.parentElement.querySelector('.prod-grid[data-full-sort]') : null;
    if(!grid || !grid.__tradeSorted) return;
    e.preventDefault();
    const p = parseInt(a.dataset.tradePage, 10);
    history.pushState({tradePage: p}, '', a.getAttribute('href'));
    renderSortedPage(grid, p, true);
  });
  window.addEventListener('popstate', function(){
    document.querySelectorAll('.prod-grid[data-full-sort]').forEach(function(grid){
      if(grid.__tradeSorted) renderSortedPage(grid, currentUrlPage(), false);
    });
  });

  function applyStateFilter(){
    const current = getState();
    document.querySelectorAll('.prod-grid').forEach(function(grid){
      labelCards(grid, current);
      if(grid.hasAttribute('data-full-sort')) applyFullSort(grid, current);
      let notice = grid.parentElement ? grid.parentElement.querySelector('.state-empty-notice') : null;
      if(current && !isShipped(current)){
        if(!notice){
          notice = document.createElement('div');
          notice.className = 'empty-state state-empty-notice';
          grid.insertAdjacentElement('afterend', notice);
        }
        notice.textContent = "We don't currently ship to this state. We ship to NSW, QLD, VIC, SA, TAS and ACT — or email trade@queensgardencentre.com.au to ask about your area.";
        grid.style.display = 'none';
      } else {
        if(notice) notice.remove();
        grid.style.display = '';
      }
    });
    const pWrap = document.querySelector('[data-product-states]');
    if(pWrap){
      const info = productStockInfo();
      const available = !current || !isShipped(current) || info.availableIn(current);
      /* Interstate stock can be quoted, so the quote module always stays visible */
      const availBlock = document.getElementById('tradeAvailableBlock');
      const unavailBlock = document.getElementById('tradeUnavailableBlock');
      if(availBlock) availBlock.style.display = '';
      if(unavailBlock) unavailBlock.style.display = 'none';
      /* highlight the selected state's chip */
      pWrap.querySelectorAll('[data-switch-state]').forEach(function(b){
        b.classList.toggle('is-current', b.dataset.switchState === current);
      });
      const statusEl = document.getElementById('regionStatus');
      if(statusEl){
        if(!current){
          statusEl.textContent = '';
          statusEl.className = 'region-status';
        } else if(!isShipped(current)){
          statusEl.textContent = "We don't currently ship to " + current + '.';
          statusEl.className = 'region-status unavailable';
        } else if(available){
          const n = info.stock[current];
          statusEl.textContent = 'In stock in ' + current + (n ? ' — ' + n + ' units' : '') + '.';
          statusEl.className = 'region-status available';
        } else {
          statusEl.textContent = 'Not available in ' + current + '.';
          statusEl.className = 'region-status unavailable';
        }
      }
      const alt = document.getElementById('geoStockAlt');
      if(alt){
        if(current && isShipped(current) && info.synced && !available){
          const others = info.states.filter(function(s){ return s !== current; });
          if(others.length){
            alt.innerHTML = '<div class="geo-alt-title">Not in stock in ' + current + '</div>'
              + '<div>Available in these states — tap one to switch:</div>'
              + '<div class="geo-alt-chips">' + others.map(function(s){
                  const n = info.stock[s];
                  return '<button type="button" class="geo-chip" data-switch-state="' + s + '">' + s + (n ? ' · ' + n + ' units' : '') + '</button>';
                }).join('') + '</div>'
              + '<div class="geo-alt-note">You can still add it to your quote list from ' + current + ' — our trade team will confirm interstate freight with your quote.</div>';
          } else {
            alt.innerHTML = '<div class="geo-alt-title">Currently out of stock in all states</div>'
              + '<div class="geo-alt-note">Email <a href="mailto:trade@queensgardencentre.com.au">trade@queensgardencentre.com.au</a> and we will let you know when it is back.</div>';
          }
          alt.hidden = false;
        } else {
          alt.innerHTML = '';
          alt.hidden = true;
        }
      }
      const stockBadge = document.getElementById('stockBadge');
      if(stockBadge){
        if(!current || !info.synced || !isShipped(current)){
          stockBadge.textContent = stockBadge.dataset.defaultText || stockBadge.textContent;
        } else {
          stockBadge.textContent = current + ' - ' + (available ? 'In stock' : 'Unavailable');
        }
        stockBadge.classList.toggle('is-unavailable', !!(current && isShipped(current) && info.synced && !available));
      }
    }
  }
  function productStockInfo(){
    const pWrap = document.querySelector('[data-product-states]');
    const states = pWrap ? (pWrap.dataset.productStates||'').split(',').map(function(s){return s.trim();}).filter(Boolean) : [];
    const synced = !!(pWrap && pWrap.dataset.synced === '1');
    let stock = {};
    try{ stock = JSON.parse((pWrap && pWrap.dataset.stock) || '{}') || {}; }catch(e){ stock = {}; }
    return {
      states: states, synced: synced, stock: stock,
      availableIn: function(code){ return (!synced && states.length===0) || states.indexOf(code) !== -1; }
    };
  }
  /* clickable state chips on product pages */
  document.addEventListener('click', function(e){
    const chip = e.target.closest('[data-switch-state]');
    if(!chip) return;
    e.preventDefault();
    setState(chip.dataset.switchState);
  });
  document.addEventListener('click', function(e){
    if(e.target.closest('#stateSelectBtn')){
      e.stopPropagation();
      const dd = document.getElementById('stateDropdown');
      if(dd) dd.classList.toggle('open');
      return;
    }
    if(!e.target.closest('.state-dropdown')){
      const dd = document.getElementById('stateDropdown');
      if(dd) dd.classList.remove('open');
    }
  });
  /* ---- end state-based location ---- */

  function renderDrawer(){
    const itemsEl = document.getElementById('drawerItems');
    const countEl = document.getElementById('drawerCount');
    const fabCountEl = document.getElementById('fabCount');
    const footCountEl = document.getElementById('drawerFootCount');
    if(!itemsEl) return;
    countEl.textContent = quoteList.length;
    fabCountEl.textContent = quoteList.length;
    const totalUnits = quoteList.reduce((s,i)=>s+i.qty,0);
    footCountEl.textContent = quoteList.length + ' line' + (quoteList.length!==1?'s':'') + ' · ' + totalUnits + ' units total';
    if(quoteList.length===0){
      itemsEl.innerHTML = '<div class="drawer-empty">No lines added yet. Browse the catalog and add products to build your list.</div>';
      return;
    }
    itemsEl.innerHTML = quoteList.map(function(item, idx){
      return '<div class="drawer-item">' +
        '<div class="thumb" style="background-image:url(\'' + (item.image||'') + '\')"></div>' +
        '<div class="d">' +
          '<h4>' + item.name + '</h4>' +
          '<div class="meta">Qty: ' + item.qty + '</div>' +
          '<button class="remove" data-remove="' + idx + '">Remove</button>' +
        '</div>' +
      '</div>';
    }).join('');
    itemsEl.querySelectorAll('[data-remove]').forEach(function(btn){
      btn.onclick = function(){ quoteList.splice(parseInt(btn.dataset.remove),1); saveList(quoteList); renderDrawer(); };
    });
  }

  document.addEventListener('click', function(e){
    const btn = e.target.closest('.btn-list');
    if(!btn) return;
    e.preventDefault();
    quoteList.push({name:btn.dataset.name, handle:btn.dataset.handle, image:btn.dataset.image, qty:10, state:getState()});
    saveList(quoteList);
    btn.textContent = 'Added';
    btn.classList.add('added');
    setTimeout(function(){ btn.textContent='Add to list'; btn.classList.remove('added'); },1200);
    renderDrawer();
  });

  const qtyInput = document.getElementById('qtyInput');
  const addBtn = document.getElementById('addToListBtn');
  if(addBtn && qtyInput){
    const unitCents = parseFloat(addBtn.dataset.unitCents || '0');
    const qtyPlus = document.getElementById('qtyPlus');
    const qtyMinus = document.getElementById('qtyMinus');
    function updateTierEstimate(){
      const q = parseInt(qtyInput.value||0);
      const totalCents = Math.round(q * unitCents);
      const tierTotalEl = document.getElementById('tierTotal');
      if(tierTotalEl) tierTotalEl.textContent = '$' + (totalCents/100).toFixed(2);
    }
    if(qtyPlus) qtyPlus.onclick = function(){ qtyInput.value = parseInt(qtyInput.value||0)+1; updateTierEstimate(); };
    if(qtyMinus) qtyMinus.onclick = function(){ qtyInput.value = Math.max(1,parseInt(qtyInput.value||1)-1); updateTierEstimate(); };
    updateTierEstimate();
    addBtn.onclick = function(){
      const cur = getState();
      const info = productStockInfo();
      const item = {name:addBtn.dataset.name, handle:addBtn.dataset.handle, image:addBtn.dataset.image, qty: parseInt(qtyInput.value||1), state:cur};
      if(cur && isShipped(cur) && info.synced && !info.availableIn(cur)){
        item.stockIn = info.states.length ? info.states.join(', ') : 'none';
      }
      quoteList.push(item);
      saveList(quoteList);
      renderDrawer();
      openDrawerFn();
    };
  }

  const drawer = document.getElementById('drawer');
  const drawerOverlay = document.getElementById('drawerOverlay');
  function openDrawerFn(){ drawer.classList.add('open'); drawerOverlay.classList.add('open'); }
  function closeDrawerFn(){ drawer.classList.remove('open'); drawerOverlay.classList.remove('open'); }
  document.getElementById('openDrawer').onclick = openDrawerFn;
  document.getElementById('fabOpenDrawer').onclick = openDrawerFn;
  document.getElementById('closeDrawer').onclick = closeDrawerFn;
  drawerOverlay.onclick = closeDrawerFn;

  const modalOverlay = document.getElementById('modalOverlay');
  document.getElementById('sendListBtn').onclick = function(){
    if(quoteList.length===0) return;
    modalOverlay.classList.add('open');
  };
  document.getElementById('cancelModal').onclick = function(){ modalOverlay.classList.remove('open'); };

  document.getElementById('submitQuote').closest('form').addEventListener('submit', function(){
    const business = document.getElementById('cf_business').value;
    const contactName = document.getElementById('cf_contactname').value;
    const region = document.getElementById('cf_region').value;
    const notes = document.getElementById('cf_notes').value;
    document.getElementById('cf_name').value = business + ' (' + contactName + ')';
    let body = 'TRADE QUOTE REQUEST\n\n';
    body += 'Business: ' + business + '\n';
    body += 'Contact: ' + contactName + '\n';
    body += 'Region: ' + region + '\n';
    body += 'Selected trade state: ' + (rawState() === 'ALL' ? 'All states' : (getState() || 'Not selected')) + '\n';
    body += 'Notes: ' + notes + '\n\n';
    body += 'Quote list:\n';
    quoteList.forEach(function(item){ body += '- ' + item.name + ' x ' + item.qty + (item.handle ? ' (/products/' + item.handle + ')' : '') + (item.state ? ' [state at add: ' + item.state + ']' : '') + (item.stockIn ? ' [NOT in stock in ' + item.state + '; stock in: ' + item.stockIn + ']' : '') + '\n'; });
    document.getElementById('cf_body').value = body;
    localStorage.setItem(STORAGE_KEY, '[]');
  });

  renderDrawer();
  renderFirstVisitGrid();
  updateStateUI();
  applyStateFilter();
  if(!rawState()){
    const fv = document.getElementById('stateFirstVisitOverlay');
    if(fv) fv.classList.add('open');
  }
